import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

interface IProps {
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  fullscreen?: boolean;
  children?: React.ReactNode;
}

export const SharedSpinner: React.FC<IProps> = ({
  size = 'medium',
  loading,
  fullscreen,
  children,
}) => {
  return (
    <Spin
      size={size}
      spinning={loading}
      description={children || fullscreen ? 'Loading...' : undefined}
      fullscreen={fullscreen}
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      {children}
    </Spin>
  );
};
